import React from 'react';
import { MessageCircle, Phone } from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { Link } from 'react-router-dom';
import { trackWebsiteOfferCta } from '../../utils/analytics';
import { OFFER_FORM_PATH, PRIMARY_CTA_CLASS, SECONDARY_CTA_CLASS, TEXT_LINK_CLASS } from './ctaStyles';
import { WHATSAPP_OFFER_URL } from './offerData';

interface CtaProps {
  location: string;
  className?: string;
}

interface FormCtaProps extends CtaProps {
  to?: string;
  label?: string;
  icon?: LucideIcon;
}

/** CTA principal : ouvre WhatsApp avec un message pré-rempli. */
export const OfferWhatsAppCta: React.FC<CtaProps> = ({ location, className = PRIMARY_CTA_CLASS }) => (
  <a
    href={WHATSAPP_OFFER_URL}
    target="_blank"
    rel="noopener noreferrer"
    className={className}
    onClick={() => trackWebsiteOfferCta(location, 'whatsapp')}
  >
    <MessageCircle className="mr-2 h-4 w-4 flex-shrink-0" aria-hidden="true" /> Discuter de mon site sur WhatsApp
  </a>
);

/** CTA secondaire : formulaire de rappel. */
export const OfferFormCta: React.FC<FormCtaProps> = ({
  location,
  to = OFFER_FORM_PATH,
  label = 'Être rappelé',
  icon: Icon = Phone,
  className = SECONDARY_CTA_CLASS,
}) => (
  <Link to={to} className={className} onClick={() => trackWebsiteOfferCta(location, 'form')}>
    <Icon className="mr-2 h-4 w-4 flex-shrink-0" aria-hidden="true" /> {label}
  </Link>
);

/** Petit lien texte vers le formulaire. */
export const OfferFormTextLink: React.FC<CtaProps> = ({ location, className = TEXT_LINK_CLASS }) => (
  <Link to={OFFER_FORM_PATH} className={className} onClick={() => trackWebsiteOfferCta(location, 'form')}>
    ou être rappelé
  </Link>
);
